import { module } from 'angular';

import { default as linkDirectiveName, LinkDirective } from './link.directive';

export default module('contact.commons.toolbox.link', []).directive(linkDirectiveName, LinkDirective).name;
